import { App, message } from "antd";
import { useDispatch } from "react-redux";

import {
  resetFields,
  setBailiffDocumentOpenUpload,
} from "store/bailiff/bailiff/document/bailiff_document.action";
import { checkPossibleToAddJob } from "store/bailiff/bailiff/job/bailiff_job.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useBailiffUpload = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleOpen = async () => {
    // check xem đủ slot để upload không.
    const possible = await checkPossibleToAddJob({ max: 30 });

    if (!possible) {
      return message.warning(
        "Vui lòng thanh toán và xử lý những file dịch chưa hoàn tất trước khi tiến hành tải lên thêm",
      );
    }

    dispatch(setBailiffDocumentOpenUpload(true));
  };
  const handleCancel = () => {
    dispatch(setBailiffDocumentOpenUpload(false));
    dispatch(resetFields());
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleOpen, handleCancel };
};
